module.exports = __webpack_public_path__ + "static/img/Blake-Steep.c5b3732.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Blake-Steep.jpg
// module id = FlQk
// module chunks = 0